import { useContent } from "contexts/contentContext/contentContext.js";
import parse from "html-react-parser";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import type { TransactionT } from "../../../../models/models";
import { DowngradeDetailsTypeE } from "../../../../models/enums";

import styles from "./styles.module.scss";

interface HeaderCompleteI {
  type: DowngradeDetailsTypeE;
  isDowngrade: boolean;
  isAddon: boolean;
  transactionDetails: TransactionT;
}

const HeaderComplete = (props: HeaderCompleteI) => {
  const { type, isDowngrade, isAddon, transactionDetails } = props;
  const { getTextByKey } = useContent();
  const getSubscriptionPeriod = () => {
    if (!transactionDetails?.PurchaseTransactionPeriodType) return;
    return getTextByKey(
      transactionDetails?.PurchaseTransactionPeriodType
    ).toLowerCase();
  };

  if (!isDowngrade) {
    switch (type) {
      case DowngradeDetailsTypeE.SUB_USERS:
        return (
          <div className={styles.subTitle}>
            <h4>
              {getTextByKey("purchase-complete-sub-users").replace(
                "#number#",
                transactionDetails.PurchaseProductQuantity
              )}
            </h4>
          </div>
        );
      case DowngradeDetailsTypeE.EXTRA_STORAGE:
        return (
          <div className={styles.subTitle}>
            <h4>
              {getTextByKey(
                "purchase-complete-extra-storages-subtitle"
              ).replace("#number#", transactionDetails.PurchaseProductQuantity)}
            </h4>
          </div>
        );
      case DowngradeDetailsTypeE.CODES:
        return (
          <>
            <div className={styles.subTitle}>
              <h4>
                {getTextByKey(transactionDetails.PurchasePageSuccessSubTitle)}{" "}
                Pay as you go - {transactionDetails.PurchaseProductQuantity}{" "}
                JUMBOcodes
              </h4>
            </div>
            <div className={styles.codesList}>
              <div className={styles.codesListTitle}>
                <h4>
                  {getTextByKey("purchase-result-success-codes-list-title")}
                </h4>
              </div>
              <div className={styles.codesListContent}>
                {transactionDetails.PurchaseCodesList &&
                  transactionDetails.PurchaseCodesList.map((code) => (
                    <div className={styles.codeItem}>{code}</div>
                  ))}
              </div>
              <div className={styles.codesListLink}>
                {/*@ts-ignore*/}
                <LinkToNewTab
                  page="user/profile/jumbocode"
                  isNewTab
                  classes={"jumbomail-link"}
                >
                  {getTextByKey("purchase-result-success-codes-list-link")}
                </LinkToNewTab>
              </div>
            </div>
          </>
        );
      case DowngradeDetailsTypeE.RENEWABLE_SUBSCRIPTION:
      case DowngradeDetailsTypeE.SUBSCRIPTION:
      case DowngradeDetailsTypeE.RENEWABLE_EMBED:
      case DowngradeDetailsTypeE.EMBED:
        return (
          <>
            <div className={styles.subTitle}>
              <h4>
                {transactionDetails &&
                transactionDetails.PurchaseIsFreeSubscriptionCoupon
                  ? getTextByKey("free")
                  : getTextByKey(
                      transactionDetails.PurchasePageSuccessSubTitle
                    )}{" "}
                {getSubscriptionPeriod()}{" "}
                {transactionDetails &&
                  getTextByKey("coupon-popup-subscription-link-text").replace(
                    "#limitProduct#",
                    transactionDetails.PurchaseTransactionProductDescription.includes(
                      ","
                    )
                      ? transactionDetails.PurchaseTransactionProductDescription.split(
                          ","
                        )[0]
                      : ""
                  )}{" "}
                {transactionDetails &&
                  transactionDetails.PurchaseIsFreeSubscriptionCoupon &&
                  `- ${
                    transactionDetails.FreeSubscriptionCouponMonthsCount
                  } ${getTextByKey("months")}`}
              </h4>
              <h4>
                {transactionDetails &&
                  parse(
                    getTextByKey(
                      transactionDetails.PurchasePageSuccessDescription
                    )
                  )}
              </h4>
            </div>
          </>
        );

      default:
        break;
    }
  } else {
    return (
      <div className={styles.subTitle}>
        <h4>
          {isAddon
            ? getTextByKey("downgrade-complete-addon-title")
            : getTextByKey("downgrade-complete-plan-title") + " " + type}
        </h4>
      </div>
    );
  }
};

export default HeaderComplete;
